<!--<contact-common-search *ngIf="isShowSearch" [execMapDuplicate]="false" [isLead]="true"></contact-common-search>-->
<lead-search-result *ngIf="user && isSearchRefresh" [user]="user" [searchData]="queryDataLoaded" [isMgrView]="true" [isFromRptFilter]="true"></lead-search-result>
